import React, { useState } from "react";

import classNames from "classnames";
import PropTypes from "prop-types";
import Select, { components } from "react-select";

import { ReactComponent as IconClearInput18 } from "../../icons/icon/18/a-icon-clearinput-18.svg";
import { ReactComponent as IconDropdownExpand18 } from "../../icons/icon/18/a-icon-dropdown-expand-18.svg";

import "./inputSelect.scss";

const DropdownIndicator = (props) => (
  <components.DropdownIndicator {...props}>
    <IconDropdownExpand18 />
  </components.DropdownIndicator>
);

const ClearIndicator = (props) => (
  <components.ClearIndicator {...props}>
    <IconClearInput18 />
  </components.ClearIndicator>
);

const InputSelect = ({
  clearable = true,
  disabled = false,
  inputId = "",
  isInvalid = false,
  isSearchable = false,
  items,
  maxMenuHeight = 180,
  name,
  onBlur = () => {},
  onChange = () => {},
  placeholder,
  value = undefined,
}) => {
  const [tmpValue, setTmpValue] = useState(value);

  return (
    <Select
      name={name}
      placeholder={placeholder}
      options={items}
      className={classNames(
        "select-container",
        {
          "is-invalid": isInvalid,
          "select-container--invalid": isInvalid,
          "select-container--placeholder-shown": typeof tmpValue === "undefined",
        },
      )}
      inputId={inputId}
      classNamePrefix="select"
      maxMenuHeight={maxMenuHeight}
      isDisabled={disabled}
      isClearable={clearable}
      blurInputOnSelect={false}
      onChange={(event) => {
        setTmpValue(event ? event.value : undefined);
        onChange(event);
      }}
      onBlur={(event) => {
        onBlur(event);
      }}
      value={value}
      components={{ ClearIndicator, DropdownIndicator }}
      menuPosition="absolute"
      menuPlacement="auto"
      isSearchable={isSearchable || items.length > 10}
      captureMenuScroll={false}
    />
  );
};

InputSelect.propTypes = {
  clearable: PropTypes.bool,
  disabled: PropTypes.bool,
  inputId: PropTypes.string,
  isInvalid: PropTypes.bool,
  isSearchable: PropTypes.bool,
  items: PropTypes.oneOfType([PropTypes.array]).isRequired,
  maxMenuHeight: PropTypes.number,
  name: PropTypes.string.isRequired,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  placeholder: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
};

export default InputSelect;
